import React from 'react'
import axios from 'axios'
// import { NavLink } from 'react-router-dom'
import { If, Then, Else, Switch, Case, Default } from 'react-if'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import { useHistory } from 'react-router-dom'
import { NavLink } from 'reactstrap'
import { FaPlusCircle, FaArrowAltCircleRight } from "react-icons/fa"
import { FcOvertime, FcApproval } from "react-icons/fc";

import { DashboardProfile } from '../components/functions/DashboardPage'
import { useSelector } from 'react-redux';
import ErrorSwal from '../components/SwalError'



const themColor = [
    { "theme": 'card-box theme-pink' },
    { "theme": 'card-box theme-yellow' },
    { "theme": 'card-box theme-blue' },
    { "theme": 'card-box theme-teal' },
    { "theme": 'card-box theme-red' },
    { "theme": 'card-box theme-dark-blue' }
]
const iconColor = [
    { "color": '#e75989' },
    { "color": '#ffc233' },
    { "color": '#66b0ff' },
    { "color": '#2bd47d' },
    { "color": '#e05260' },
    { "color": '#3d4dc5' },

]

const DataLeave = () => {
    const { t } = useTranslation()
    const [error, setError] = React.useState(null)
    const [leaveInfo, setLeaveInfo] = React.useState([])
    const [leaveApprove, setLeaveApprove] = React.useState([])
    const cancelToken = React.useRef(null)
    const profileRedux = useSelector(state => state.authReducer.profile)
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const history = useHistory()
    const getData = async () => {
        try {

            const resp = await DashboardProfile()
            // console.log(resp)
            setLeaveInfo(resp.data.leaveTypes)
            setLeaveApprove(resp.data.leaveApprove)

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }
    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source()

        getData()

        return () => {
            cancelToken.current.cancel()
        }
    }, [])

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    return (

        <>
            {/* Dot show Menubar Approve Not Admin user */}
            {profileRedux ? (
                <If condition={profileRedux.APPROVE_PERSON === "1"}>
                    <Then>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                            <div className='card-box theme-dark-blue' style={leaveApprove > 0 ? { backgroundColor: 'rgb(61 87 139)' } : {}} onClick={() => history.push('/approve/')}>
                                <div className="row-detail-inside">
                                    <div className="box-detail-inside">
                                        <div className="align-content-between">
                                            <p className="text-title-inside" style={leaveApprove > 0 ? { color: '#fff' } : {}}>
                                                {t("t_pending_approval")}
                                            </p>
                                            <p className="text-value-inside" style={leaveApprove > 0 ? { color: '#fff' } : {}}>{leaveApprove}</p>
                                            <div className="footer-link">
                                                <span >
                                                    <NavLink style={leaveApprove > 0 ? { color: '#fff' } : {}} onClick={() => history.push('/approve/')}  >
                                                        {/* <i className="fas fa-angle-right"></i> */}
                                                        <FaArrowAltCircleRight color={'#364b98'} />
                                                        {' '}
                                                        {t("b_more_dtl")}
                                                    </NavLink>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-icon-inside">
                                        <div className="box-icon">
                                            {/* <i className="fas fa-stamp"></i> */}
                                            <FcApproval size={'2em'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Then>
                    <Else>
                        <> </>
                    </Else>
                </If>
            ) : (
                <></>
            )

            }
            {
                leaveInfo.map((value, index) => {
                    return (
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" key={index}>
                            <div className={themColor[index].theme} onClick={() => history.push('/request/' + value.TYPECD)}>
                                <div className="row-detail-inside">
                                    <div className="box-detail-inside">
                                        <div className="align-content-between">

                                            <p className="text-title-inside">
                                                <Switch>
                                                    <Case condition={currentLanguageCode === 'en'}> {value.TYPENM} </Case>
                                                    <Case condition={currentLanguageCode === 'th'}> {value.TYPENM2} </Case>
                                                    <Case condition={currentLanguageCode === 'jp'}> {value.TYPENM3} </Case>
                                                    <Default> {value.TYPENM} </Default>
                                                </Switch>

                                            </p>

                                            <p className="text-value-inside">{value.UseDay}/{value.DEFULT_ANNUAL}</p>

                                            <div className="footer-link">
                                                <span>
                                                    <NavLink onClick={() => history.push('/request/' + value.TYPECD)} >
                                                        {/* <i className="fas fa-plus"></i> */}
                                                        <FaPlusCircle color={iconColor[index].color} />
                                                        {' '}
                                                        {t("b_new")}
                                                    </NavLink>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-icon-inside">
                                        <div className="box-icon">
                                            {/* <i className="fas fa-hourglass-half"></i> */}
                                            <FcOvertime size={'2em'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </>
    )
}

export default DataLeave;